import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { GButton } from 'components/basic-blocks'
import { useAccountStore } from 'store'
import { FiPlus } from 'react-icons/fi'
import { useTrackPostHogEvent } from '../../utils/posthog'
import { PostHogEvent, PostHogPath } from '../../utils/posthog-events'

interface CreditCardExpiryBannerProps {
	disablePadding?: boolean
}

export const CreditCardExpiryBanner = ({ disablePadding = false }: CreditCardExpiryBannerProps) => {
	const navigate = useNavigate()
	const { account } = useAccountStore()
	const accountId = account?.id
	const trackPostHogEvent = useTrackPostHogEvent()

	useEffect(() => {
		if ((window as any).dataLayer) {
			(window as any).dataLayer.push({
				event: 'cc_expiry_banner_impression'
			})
		}
		trackPostHogEvent(
			PostHogEvent.BANNER_IMPRESSION,
			PostHogPath.CC_EXPIRATION_BANNER,
			null
		)
	}, [trackPostHogEvent])

	const handleUpdateClick = () => {
		if ((window as any).dataLayer) {
			(window as any).dataLayer.push({
				event: 'cc_expiry_banner_cta_click'
			})
		}
		trackPostHogEvent(
			PostHogEvent.CTA_CLICK,
			PostHogPath.CC_EXPIRATION_BANNER,
			null
		)
		navigate(`/settings/workspace/${accountId}/billing?tab=methods`)
	}

	return (
		<div className={`w-full ${disablePadding ? 'px-4' : 'px-4 sm:px-6 md:px-8 md:pe-12'}`}>
			<div className="app-notice-banner max-w-8xl mx-auto bg-t-step-inactive rounded-3xl py-5 px-6 mb-2">
				<div className="flex items-center justify-between">
					<p className="text-md font-medium text-t-base-blue pr-4">
						Your payment method will expire soon. Update your card to ensure your websites stay protected.
					</p>
					<div className="flex items-center ml-4">
						<GButton
							onClick={handleUpdateClick}
							icon={FiPlus}
							color="yellow"
							labelClassName="font-medium text-base"
							className=" rounded-full disabled:!shadow-none !shadow-s-yellow"
						>
						Update Payment Method
						</GButton>
						
					</div>
				</div>
			</div>
		</div>
	)
}

